module.exports = __webpack_public_path__ + "static/media/in-the-dream-house.eb099eda.jpg";